<template>
  <v-container class="pt-5 pb-7">
    <v-layout row wrap>
      <v-flex xs12>
        <vue-dropzone id="dropzone" ref="dropzone" :options="dropzoneOptions" duplicate-check @vdropzone-queue-complete="onComplete" @vdropzone-complete="onFileComplete" />
      </v-flex>
    </v-layout>
    <v-layout row wrap class="pt-5" justify-content-center>
      <v-flex md5>
        <p class="headline">
          Uncategorized Files
        </p>
        <div v-if="initLoading" class="text-xs-center pt-5">
          <v-progress-circular :size="70" :width="7" color="secondary" indeterminate />
        </div>
        <v-list v-else two-line dense style="max-height: 500px;overflow-y: auto;">
          <template v-for="(file, index) in uncategorizedFiles">
            <v-list-tile :key="file.createdAt" avatar>
              <v-list-tile-avatar tile>
                <v-img :src="file.iconUrl" contain />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  <a target="_blank" :href="'/resources/'+file.id" :download="file.name">{{ file.name }}</a>
                </v-list-tile-title>
                <v-list-tile-sub-title>{{ file.createdAt | formatDate }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon ripple :loading="deleteFileId === file.id" @click="deleteFile(file.id)">
                  <v-icon color="grey lighten-1" small>
                    far fa-trash-alt
                  </v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="uncategorizedFiles.length !== index+1" :key="file.id" />
          </template>
        </v-list>
      </v-flex>
      <v-flex md1 class="text-xs-center">
        <v-divider vertical class="ma-0" />
      </v-flex>
      <v-flex md5>
        <p class="headline">
          Categorized Files
        </p>
        <div v-if="initLoading" class="text-xs-center pt-5">
          <v-progress-circular :size="70" :width="7" color="secondary" indeterminate />
        </div>
        <v-list v-else two-line dense style="max-height: 500px;overflow-y: auto;">
          <template v-for="(file, index) in categorizedFiles">
            <v-list-tile :key="file.createdAt">
              <v-list-tile-avatar tile>
                <v-img :src="file.iconUrl" contain />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  <a target="_blank" :href="'/resources/'+file.id" :download="file.name">{{ file.name }}</a>
                </v-list-tile-title>
                <v-list-tile-sub-title>{{ file.createdAt | formatDate }} - {{ file.directory }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon ripple :loading="deleteFileId === file.id" @click="deleteFile(file.id, 'categorized')">
                  <v-icon color="grey lighten-1">
                    far fa-trash-alt
                  </v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="categorizedFiles.length !== index+1" :key="file.id" />
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
  <script>
  import axios from 'axios';
  import vue2Dropzone from 'vue2-dropzone';
  import ManageCourseBase from './ManageCourseBase.vue';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';

  export default {
    components: {
      vueDropzone: vue2Dropzone,
    },
    extends: ManageCourseBase,

    props: {
      selectedTab: {
        type: String,
        default: '',
      },
    },

    data: () => ({
      dropzoneOptions: {
        timeout: 180000,
        method: 'post',
        url: '/api/photos/',
        thumbnailWidth: 150,
        maxFilesize: 300,
      },
      deleteFileId: null,
      uncategorizedFiles: [],
      categorizedFiles: [],
      initLoading: true,
    }),

    watch: {
      selectedTab(newVal) {
        if (newVal === 'Files') {
          this.init();
        }
      },
    },

    mounted() {
      this.init().then(() => {
        this.initLoading = false;
      });
    },

    methods: {
      async init() {
        this.$refs.dropzone.setOption('url', `/api/courses/${this.courseId}/items`);
        await this.getUncategorizedFiles();
        await this.getCategorizedFiles();
      },

      async getUncategorizedFiles() {
        const { data } = await axios.get(`/api/courses/${this.courseId}/items/uncategorized`);
        this.uncategorizedFiles = data;
      },

      async getCategorizedFiles() {
        const { data } = await axios.get(`/api/courses/${this.courseId}/items/categorized/files`);
        this.categorizedFiles = data;
      },

      async deleteFile(itemId, type = 'uncategorized') {
        this.deleteFileId = itemId;
        await axios.delete(`/api/courses/${this.courseId}/items/${itemId}`);
        if (type === 'uncategorized') {
          this.getUncategorizedFiles();
        } else {
          this.getCategorizedFiles();
        }
        this.deleteFileId = null;
      },

      async onComplete() {
        await this.getUncategorizedFiles();
      },

      onFileComplete(file) {
        this.$refs.dropzone.removeFile(file);
      },
    },
  };
  </script>